/* global Sys, Core, Resources */
Sys.ns("Core");

/**
 * The NetEnt Extend model.
 *
 * @class Core.NetEntExtendModel
 * @extends Core.Model
 */
Core.NetEntExtendModel = {

    /**
     * The available error codes.
     */
    ERROR_CODES: {
        UNKNOWN_ERROR: 0,
        ILLEGAL_ARGUMENT: 1,
        EVENTS_NOT_AVAILABLE_IN_GAME: 7,
        CALLBACK_NOT_PROVIDED: 8,
        FUNCTIONALITY_NOT_AVAILABLE: 9,
        WRONG_NUMBER_OF_ARGUMENTS: 10,
        NO_RESPONSE_FROM_GAME: 11,
        NOT_AVAILABLE_IN_CURRENT_STATE: 12,
        HTML_GAME_LAUNCH_FAILED: 18
    },

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.NetEntExtendModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @inheritdoc
     */
    setupData: function() {
        var me = this,
            gameServerInitResponse = Resources.readData("gameServerInitResponse"),
            gameEventSetters = (Sys.isDefined(gameServerInitResponse)) ? gameServerInitResponse["gameEventSetters.enabled"] : false,
            restricted = false;

        if (Sys.isDefined(gameEventSetters) && gameEventSetters === true) {
            restricted = true;
        }

        me.storeData("useRestricted", restricted);
        me.storeData("locked", true);

        me.storeData("inIdleState", false);

        me.storeData("featureSplash.showing", false);
    }
};

Core.NetEntExtendModel = Sys.extend(Core.Model, Core.NetEntExtendModel, "Core.NetEntExtendModel");
